/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  GetBoxesService,
  IGetBoxesMethods,
  ICreatePayTxMethods,
  CreatePayTxService,
  IUpdateBoxMethods,
  UpdateBoxService,
  UpdateValidEmailIDService,
  IUpdateValidEmailIDMethods,
  IGetInvoicePdfTypeMethods,
  GetInvoicePdfService,
  UpdateDelegateNameService,
  IShareInvoiceMethods,
  ShareInvoiceService,
  IUpdateDelegateNameMethods,
  IChangeModeMethods,
  ChangeModeService,
  TransferBoxService,
  ITransferBoxMethods,
  IAddBoxNoteMethods,
  AddBoxNoteService,
  ICheckPaymentFromPGTypeMethods,
  CheckPaymentFromPGService,
  IDeletePayTxTypeMethods,
  DeletePayTxService,
  IGetBoxesYearMethods,
  GetBoxesYearService,
  IGetPastPurchaseBoxesMethods,
  GetPastPurchaseBoxesService,
  ICreatePayFACMethods,
  CreatePayFACService,
  IValidateDiscountMethods,
  ValidateDiscountService,
  IRefundTransactionMethods,
  RefundTransactionService,
  IAdjustmentMethods,
  AdjustmentService,
  IGetCitiesMethods,
  GetCitiesService,
  IGetMyDiscountMethods,
  GetMyDiscountService,
  IMarkAsDeliveredMethods,
  MarkAsDeliveredService,
  ISaveNotesMethods,
  SaveNotesService,
  IgetDeliveryReceiptTypeMethods,
  getDeliveryReceiptService,
  GetSchedulesService,
  IGetSchedulesMethods,
} from "./components";

export type PurchasedCostumePageAgent = IStaticPageContentMethods &
  IGetBoxesMethods &
  IUpdateBoxMethods &
  ICreatePayTxMethods &
  IUpdateValidEmailIDMethods &
  IUpdateDelegateNameMethods &
  IChangeModeMethods &
  IAdjustmentMethods &
  ITransferBoxMethods &
  IRefundTransactionMethods &
  IShareInvoiceMethods &
  IGetInvoicePdfTypeMethods &
  IAddBoxNoteMethods &
  IgetDeliveryReceiptTypeMethods &
  IGetMyDiscountMethods &
  IGetBoxesYearMethods &
  ICheckPaymentFromPGTypeMethods &
  IGetPastPurchaseBoxesMethods &
  IGetSchedulesMethods &
  IGetCitiesMethods &
  IDeletePayTxTypeMethods &
  IValidateDiscountMethods &
  ISaveNotesMethods &
  IAdjustmentMethods &
  IMarkAsDeliveredMethods &
  ICreatePayFACMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new UpdateBoxService(),
    new ShareInvoiceService(),
    new GetBoxesService(),
    new GetSchedulesService(),
    new getDeliveryReceiptService(),
    new GetMyDiscountService(),
    new CreatePayTxService(),
    new SaveNotesService(),
    new UpdateValidEmailIDService(),
    new GetInvoicePdfService(),
    new UpdateDelegateNameService(),
    new ChangeModeService(),
    new GetCitiesService(),
    new TransferBoxService(),
    new GetBoxesYearService(),
    new AddBoxNoteService(),
    new RefundTransactionService(),
    new CheckPaymentFromPGService(),
    new GetPastPurchaseBoxesService(),
    new DeletePayTxService(),
    new CreatePayFACService(),
    new ValidateDiscountService(),
    new AdjustmentService(),
    new MarkAsDeliveredService(),
  ];
};

export const getAgent = () => {
  return createAgent<PurchasedCostumePageAgent>({
    plugins: getPlugins(),
  });
};
